<template>
  <div class="imp-banner" role="alert">
    <span class="mdi mdi-shield-alert-outline imp-banner__icon"></span>
    <p class="imp-banner__text">
      Modo impersonación activo · Estás viendo <strong>{{ info.parkName }}</strong> como administrador ·
      Todo lo que hagas quedará registrado en la bitácora
    </p>
    <button type="button" class="imp-banner__exit" :disabled="leaving" @click="onExit">{{ leaving ? 'Saliendo…' : 'Salir' }}</button>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useAuthStore } from '@/services/authStore'

defineProps({ info: { type: Object, required: true } })

const { exitImpersonation } = useAuthStore()
const leaving = ref(false)

async function onExit() {
  leaving.value = true
  try {
    await exitImpersonation()
  } catch {
    // Aunque falle la petición, se recarga: la sesión de clientes vence sola a las 2 h.
  }
  // Recarga completa para no arrastrar datos del parque a la vista del panel.
  window.location.assign('/superadmin/parques')
}
</script>

<style scoped>
.imp-banner {
  position: fixed; top: 0; left: 0; right: 0; height: 48px; z-index: 20000;
  display: flex; align-items: center; gap: 12px; padding: 0 16px; background: #e84545; color: #fff;
}
.imp-banner__icon { font-size: 20px; flex-shrink: 0; }
.imp-banner__text { flex: 1; min-width: 0; margin: 0; font: 500 12px Inter, sans-serif; line-height: 1.3; }
.imp-banner__exit {
  flex-shrink: 0; background: transparent; color: #fff; border: 1px solid #fff; border-radius: 6px; padding: 5px 16px;
  font: 600 12px Inter, sans-serif; cursor: pointer;
}
.imp-banner__exit:hover:not(:disabled) { background: rgba(255, 255, 255, 0.18); }
@media (max-width: 768px) {
  .imp-banner__text { font-size: 10px; }
  .imp-banner__icon { display: none; }
}
</style>